<template>
  <div :data-column="column" class="modifier-box flex">
    <div class="mainLabel">
      {{ mainLabel }}
    </div>
    <div class="flex modifier-container">
      <div class="modifier-top">
        <div class="left-right-text">
          <span class="left-text">{{ leftText }}</span>
          <span class="right-text">{{ rightText }}</span>
        </div>
      </div>
      <div class="modifier-bottom">
        <div class="sliders">
          <vue-slider
            v-if="sliders.sliderLeft.width"
            :width="sliders.sliderLeft.width"
            :adsorb="true"
            :interval="parseFloat(step)"
            :data="sliders.sliderLeft.data"
            :marks="true"
            :disabled="true"
          >
            <template v-slot:dot>
              <img src="" class="custom-dot" alt="" />
            </template>
          </vue-slider>
          <vue-slider
            v-if="sliders.sliderMiddle.width"
            ref="slider"
            v-model="val"
            :width="sliders.sliderMiddle.width"
            :adsorb="true"
            :interval="1"
            :included="true"
            :marks="sliders.sliderMiddle.marks"
            :tooltip="'always'"
            :tooltip-formatter="tooltipFormatter"
            :tooltip-placement="'bottom'"
            @change="onChange"
          >
            <template v-slot:dot>
              <img
                :src="imgUrl"
                width="18"
                height="18"
                class="custom-dot"
                value="0"
                alt=""
              />
            </template>
          </vue-slider>
          <vue-slider
            v-if="sliders.sliderRight.width"
            :width="sliders.sliderRight.width"
            :adsorb="true"
            :interval="parseFloat(step)"
            :data="sliders.sliderRight.data"
            :marks="true"
            :disabled="true"
          >
            <template v-slot:dot>
              <img src="" class="custom-dot" alt="" />
            </template>
          </vue-slider>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import '../assets/slider-theme.css'

export default {
  name: 'modifier',
  props: {
    column: {
      type: String,
      default: ''
    },
    initVal: {
      type: [Number, String],
      default: 0
    },
    value: {
      type: [Number, String],
      default: 0
    },
    step: {
      type: [Number, String],
      default: 0.5
    },
    sliderDisplayMin: {
      type: [Number, String],
      default: -2
    },
    sliderValidMin: {
      type: [Number, String],
      default: -1.5
    },
    sliderValidMax: {
      type: [Number, String],
      default: 1.5
    },
    sliderDisplayMax: {
      type: [Number, String],
      default: 2
    },
    sliderPops: {
      type: Array,
      default: null
    },
    sliderWidth: {
      type: [Number, String],
      default: 400
    },
    imgUrl: {
      type: String,
      // eslint-disable-next-line global-require
      default: require('./../assets/slider.png')
    },
    leftText: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    },
    mainLabel: {
      type: String,
      default: ''
    }
  },
  components: {
    VueSlider
  },
  data() {
    return {
      val: 0
    }
  },
  computed: {
    sliders() {
      let sliderLeft = {}
      let sliderMiddle = {}
      let sliderRight = {}

      const displayMin = parseFloat(this.sliderDisplayMin)
      const displayMax = parseFloat(this.sliderDisplayMax)
      const validMin = parseFloat(this.sliderValidMin)
      const validMax = parseFloat(this.sliderValidMax)
      const totalRange = displayMax - displayMin
      const totalWidth = parseFloat(this.sliderWidth)

      sliderMiddle = this.calcRailProps(
        validMin,
        validMax,
        this.sliderPops,
        totalRange,
        totalWidth
      )

      if (this.sliderDisplayMin < this.sliderValidMin) {
        sliderLeft = this.calcRailProps(
          displayMin,
          validMin,
          this.sliderPops,
          totalRange,
          totalWidth
        )
      }

      if (this.sliderDisplayMax > this.sliderValidMax) {
        sliderRight = this.calcRailProps(
          validMax,
          displayMax,
          this.sliderPops,
          totalRange,
          totalWidth
        )
      }

      return {
        sliderLeft,
        sliderMiddle,
        sliderRight
      }
    }

  },
  watch: {
    initVal: {
      handler() {
        this.calcVal()
      },
      immediate: false
    }
  },
  mounted() {
    this.calcVal()
  },
  methods: {
    decimalsFromStep(step) {
      const s = String(step)
      if (!s.includes('.')) return 0
      return s.split('.')[1].length
    },
    toStepPrecision(n) {
      const decimals = this.decimalsFromStep(parseFloat(this.step))
      const num = parseFloat(n)
      if (Number.isNaN(num)) return 0
      return parseFloat(num.toFixed(decimals))
    },
    formatForDisplay(n) {
      const decimals = this.decimalsFromStep(parseFloat(this.step))
      const num = parseFloat(n)
      if (Number.isNaN(num)) return ''
      return decimals > 0 ? num.toFixed(decimals) : String(Math.trunc(num))
    },
    tooltipFormatter(v) {
      const mark = this.sliders.sliderMiddle.marks[v]
      if (!mark) return ''
      if (mark.displayLabel !== undefined && mark.displayLabel !== null) return mark.displayLabel
      return mark.label
    },
    calcVal(){
      const init = this.toStepPrecision(this.initVal)
      let bestKey = null
      let bestDist = Number.POSITIVE_INFINITY

      Object.keys(this.sliders.sliderMiddle.marks).forEach((key) => {
        const label = this.toStepPrecision(this.sliders.sliderMiddle.marks[key]['label'])
        const dist = Math.abs(label - init)
        if (dist < bestDist) {
          bestDist = dist
          bestKey = key
        }
      })

      if (bestKey !== null) this.val = bestKey
    },
    calcRailProps(start, stop, pops, totalRange, totalWidth) {
      const intervals = (stop - start) / this.step
      const safeTotalRange = totalRange > 0 ? totalRange : (stop - start)
      const safeTotalWidth = totalWidth > 0 ? totalWidth : 400
      const width = safeTotalRange > 0 ? ((stop - start) / safeTotalRange) * safeTotalWidth : safeTotalWidth
      let marks = {}
      let data = Array.from(
        { length: intervals + 1 },
        (_, i) => this.toStepPrecision(parseFloat(start) + i * this.step)
      ).filter((item) => {
        if (!pops) {
          return true
        } else {
          return !pops.includes(item)
        }
      })
      data.forEach(
          (ele)=>{
            const section = Math.round(((ele - data[0]) / this.step / intervals) * 100)
            this.$set(marks, section, { label: ele, displayLabel: this.formatForDisplay(ele) })
          }
        )
      return {
        intervals,
        width,
        marks,
        data
      }
    },
    onChange(value) {
      const mark = this.sliders.sliderMiddle.marks[value]
      if (!mark) return
      const realVal = this.toStepPrecision(mark.label)
      this.$emit('input', realVal)
      this.$emit('modified', { key: this.column, val: realVal })
    }
  }
}
</script>
<style scoped>
.modifier-box {
  margin-bottom: 24px;
  width: 500px;
}

.flex {
  display: flex;
  justify-content: center;
}

.modifier-container {
  position: relative;
  float: right;
  height: 36px;
  width: 500px;
  display: flex;
  justify-content: center;
}

.modifier-top,
.modifier-bottom {
  position: absolute;
}

.modifier-top {
  top: 0;
}

.modifier-bottom {
  bottom: 0;
}

.left-right-text {
  display: flex;
  justify-content: space-between;
}

.left-text {
  width: 160px;
  text-align: center;
}

.right-text {
  width: 160px;
  text-align: center;
}

.mainLabel {
  width: 50px;
  text-align: center;
  vertical-align: bottom;
}

.sliders {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// Modifier.vue?2f9c908e